module.exports = __webpack_public_path__ + "static/media/150_light.0a3694d2.svg";